import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

function OAuthCallback() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true); // State for loading feedback
  const [error, setError] = useState(null); // State for error feedback

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const authCode = queryParams.get('code');

    if (authCode) {
      // Call your backend to handle the authorization code
      fetch(`${process.env.REACT_APP_API_URL}/api/google/oauth-callback?code=${authCode}`, {
        method: 'GET',
        credentials: 'include',
      })
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then(data => {
          if (data.success) {
            alert('Google Calendar synced successfully!');
            navigate('/dashboard'); // Redirect to your dashboard
          } else {
            setError('Error syncing Google Calendar');
          }
        })
        .catch(error => {
          console.error('Error during Google OAuth callback:', error);
          setError('OAuth flow failed. Please try again.');
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      console.error('No auth code provided');
      setError('No authorization code found in the URL.');
      setLoading(false);
    }
  }, [navigate]);

  return (
    <div>
      {loading ? (
        <h2>Authorizing...</h2>
      ) : error ? (
        <div style={{ color: 'red' }}>
          <h2>{error}</h2>
        </div>
      ) : (
        <h2>Redirecting...</h2>
      )}
    </div>
  );
}

export default OAuthCallback;
